import { useRecoilState } from 'recoil';
import { dialogState } from '../recoil/dialog/dialogAtom';

export default function useDialog() {
  const [dialog, setDialog] = useRecoilState(dialogState);

  const showDialog = ({ dialogType, dialogProps }) => {
    setDialog({ dialogType, dialogProps });
  };

  const hideDialog = () => {
    setDialog(null);
  };

  return {
    dialog,
    setDialog,
    showDialog,
    hideDialog,
  };
}
